// Comisiones de las OTAs (7-oct-2026). «Lo que te llega» en la ficha de la reserva
// (components/Reservas/PayData.vue): total − comisión de la OTA − IVA de la comisión.
// Placeholders: {channel} nombre del canal, {rate} y {vat} porcentajes ya formateados,
// {base} y {amount} importes ya formateados, {unit} tipo de habitación.
export const otaNet = {
  title: "Co do Ciebie trafia",
  gross: "Suma rezerwacji",
  grossOnChannel: "Suma rezerwacji w {channel}",
  grossOfUnit: "Razem: {unit}",
  commission: "Prowizja i opłaty {channel} ({rate}%)",
  commissionOfBase: "Prowizja i opłaty {channel} ({rate}% od {base})",
  commissionReal: "Prowizja {channel} (zgłoszona przez kanał)",
  vat: "VAT od prowizji ({vat}%)",
  net: "Otrzymujesz (ok.)",
  howItWorks: "Jak to jest liczone",
  infoEstimate: "Szacunek według procentów z „Prowizje OTA” obiektu. OTA może przelać nieco inną kwotę (zaokrąglenia, promocje, opłaty za płatność).",
  infoBase: "Od opłaty miejscowej i kaucji nie pobiera się prowizji.",
  infoReal: "Prowizję za tę rezerwację podał kanał {channel}. VAT od prowizji to szacunek według procentu z „Prowizje OTA”, więc kwota, którą otrzymasz, nadal jest przybliżona.",
  infoRealNoVat: "Prowizję za tę rezerwację podał kanał {channel}. Mimo to przelew może się nieco różnić (zaokrąglenia, opłaty za płatność).",
  airbnbNet: "Airbnb wypłaca już kwotę netto: widzisz dokładnie to, co otrzymujesz.",
  apart: "Nie obejmuje {amount} pobieranych osobno: to nie przechodzi przez {channel}.",
  theChannel: "OTA",
};
